export default __webpack_public_path__ + "static/mastercard-2-e16a8159d09fc8596c0d7d1d02ec1589.svg";